import { Controller } from "@hotwired/stimulus"
import { FetchRequest } from "@rails/request.js"

export default class extends Controller {
  static values = {
    url: String,
    interval: { type: Number, default: 5000 }
  }

  connect() {
    this.startRefreshing()
  }

  disconnect() {
    this.stopRefreshing()
  }

  async startRefreshing() {
    this.timer = setInterval(() => {
      this.refresh()
    }, this.intervalValue)
  }

  async refresh() {
    const request = new FetchRequest("get", this.urlValue, {
      responseKind: "turbo-stream"
    })

    await request.perform()
  }

  stopRefreshing() {
    if (this.timer) clearInterval(this.timer)
  }
}
